import { render, staticRenderFns } from "./AgreementPage.vue?vue&type=template&id=97eeab00&scoped=true"
import script from "./AgreementPage.vue?vue&type=script&lang=js"
export * from "./AgreementPage.vue?vue&type=script&lang=js"
import style0 from "./AgreementPage.vue?vue&type=style&index=0&id=97eeab00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eeab00",
  null
  
)

export default component.exports